"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var setListMenuDomRect = function (isOpen, listRef, anchorRef) {
    if (!listRef.current || !anchorRef.current)
        return;
    if (!isOpen) {
        // hide the list when it isn't opened to prevent flicking
        listRef.current.style.visibility = 'hidden';
        return;
    }
    var _a = _1.getListMenuDomRect(anchorRef.current, listRef.current), left = _a.left, top = _a.top, width = _a.width;
    listRef.current.style.top = top + "px";
    listRef.current.style.left = left + "px";
    listRef.current.style.width = width + "px";
    listRef.current.style.visibility = 'visible';
};
exports.default = setListMenuDomRect;
//# sourceMappingURL=setListMenuDomRect.js.map